/**
 * 弹屏活动注册中心
 * 各活动插件通过 registerPopupActivity 注册，登录成功后调用 initPopupActivities 并行初始化
 */

const registry = []

/**
 * 注册弹屏活动
 * @param {Object} activity
 * @param {string} activity.id - 活动唯一标识
 * @param {number} activity.priority - 队列优先级
 * @param {string[]} activity.blockers - 阻塞条件
 * @param {Function} activity.init - 初始化函数（请求 API + 入队）
 */
export function registerPopupActivity(activity) {
  registry.push(activity)
}

/**
 * 并行初始化所有已注册活动
 * @param {Object} context
 * @param {import('@/tool/popupQueue').PopupQueue} context.popupQueue - 队列管理器
 * @param {Object} context.store - Vuex store
 * @param {Function} context.showPopup - 展示弹窗回调 (id, data) => void
 */
export async function initPopupActivities(context) {
  await Promise.allSettled(registry.map((activity) => activity.init(context)))
}
